import { render, staticRenderFns } from "./ImageContentBlockForm.vue?vue&type=template&id=9ca9646c&"
import script from "./ImageContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./ImageContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports